export const config = {
  title: 'Kelsor Cleaning Co.',
  meta: {
    description:
      'Kelsor Cleaning Co. offers professional commercial and short-term rental cleaning services in Austin, TX, and surrounding areas. We specialize in janitorial services, pressure washing, and property maintenance.',
    keywords: [
      'Kelsor Cleaning Co.',
      'Commercial Cleaning Austin',
      'Short-Term Rental Cleaning',
      'Janitorial Services',
      'Pressure Washing Austin',
      'Property Maintenance',
    ],
    author: 'Kelsor Cleaning Co.',
    canonicalUrl: 'https://www.kelsorcleaning.com/',
  },
  sections: {
    header: {
      businessName: 'Kelsor Cleaning Co.',
    },
    sectionB: {
      heroTitle: 'Kelsor Cleaning Co.',
      heroSubtitle: 'Commercial Cleaning • Short Term Rental Cleaning • Austin, TX',
      learnAboutText: 'Learn More',
      phoneNumber: '7133251247',
      phoneLabel: '(713) 325-1247',
      heroBackgroundImage:
      'https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=',
      cardData: [
        {
          title: 'Precision and Professionalism',
          description:
            'We pride ourselves on delivering precise and professional cleaning services tailored to your needs.',
        },
        {
          title: 'Flexible Scheduling',
          description:
            'Our team offers flexible scheduling to accommodate your business operations and ensure minimal disruption.',
        },
        {
          title: 'Eco-Friendly Options',
          description:
            'We offer eco-friendly cleaning products upon request, ensuring a safe environment for your staff and clients.',
        },
      ],
      description:
        'Kelsor Cleaning Co. is an Austin-based commercial cleaning company built on precision, professionalism, and pride. We specialize in janitorial services, pressure washing, and property maintenance for businesses, residential communities, and short-term rental owners across Central Texas.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of professional cleaning services designed to meet the unique needs of your space.',
      cards: [
        {
          title: 'Intermediate Service',
          description:
            'Perfect for small offices, studios, or storefronts, offering full restroom cleaning, kitchen/break room surface wipe downs, dusting, and floor care.',
          imageSrc: 'https://images.squarespace-cdn.com/content/v1/67ec3e0b928b4d59981218d3/1743880372477-7Y3XA8641URRYPOJC92O/unsplash-image-MwW-zrkYSIU.jpg?format=1500w',
          imageAlt: 'Intermediate Cleaning Service',
        },
        {
          title: 'Basic Service',
          description:
            'Ideal for routine upkeep or light refreshes, including sweeping, mopping, vacuuming main areas, surface wipe downs, and restroom spot cleaning.',
          imageSrc: 'https://images.squarespace-cdn.com/content/v1/67ec3e0b928b4d59981218d3/1743880336828-FVNX39NNQG4RVVCHGFNZ/unsplash-image-jjrXvzbqC5E.jpg?format=1500w',
          imageAlt: 'Basic Cleaning Service',
        },
        {
          title: 'Advanced Service',
          description:
            'Best suited for larger offices, retail spaces, or deep cleans, including full janitorial sweep, high-dust and detail cleaning, trash and recycling service, and sanitization of high traffic areas.',
          imageSrc: 'https://images.squarespace-cdn.com/content/v1/67ec3e0b928b4d59981218d3/1743537283790-S16KPQL8N515L06OV5NN/unsplash-image-BuDD1HGco-4.jpg?format=1500w',
          imageAlt: 'Advanced Cleaning Service',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Pressure Washing',
        'Property Maintenance',
        'Short-Term Rental Turnover Cleaning',
        'Move-In/Move-Out Cleaning',
        'Customized Cleaning Plans',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1448485337/photo/living-room-interior-with-sofa-wicker-armchair-cactus-plant-and-coffee-table.jpg?s=612x612&w=0&k=20&c=I67YxAqtNWwLephUblvejWionL0oPdyWzXlL3bSdFkM=',
        alt: 'Kelsor Cleaning Co. Team',
      },
      aboutText: [
        'Kelsor Cleaning Co. is an Austin-based commercial cleaning company built on precision, professionalism, and pride.',
        'We specialize in janitorial services, pressure washing, and property maintenance for businesses, residential communities, and short-term rental owners across Central Texas.',
        'Our mission is simple: raise the standard for janitorial and exterior cleaning services in Austin and surrounding areas.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Kelsor Cleaning Co. Logo',
      businessName: 'Kelsor Cleaning Co.',
      contact: {
        phone: '7133251247',
        phoneLabel: '(713) 325-1247',
        email: 'Office@KelsorCleaning.com',
        website: 'https://www.kelsorcleaning.com/',
        address: '9901 Brodie Lane Ste 160 #1179, Austin, TX 78748',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '9901 Brodie Lane Ste 160 #1179, Austin, TX 78748',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3476.1234567890123!2d-97.1234567890123!3d30.1234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1234567890abcdef%3A0xabcdef1234567890!2s9901+Brodie+Ln+Ste+160+%231179%2C+Austin%2C+TX+78748!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus',
    },
  },
};

export default config;
